import React from "react";
import { TabContent, TabPane } from "reactstrap";
import { Link } from "react-router-dom";

//Assets
import {
  ChevronRight,
  SettingsCrossbeamIcon,
  SettingsRevealIcon,
  GmailIcon
} from "../../../../assets/img/icons";

// Constants
import {
  INTEGRATION_ACCOUNT_MAPPING_SUB_TAB,
  INTEGRATION_ACCOUNT_MAPPING_URL_TAB,
  TAB_CROSSBEAM,
  TAB_INTEGRATION,
  TAB_REVEAL,
  TAB_GMAIL,
  TAB_SNOWFLAKE
} from "../../../../setting/Constants";
import CrossbeamSection from "../../../../crossbeam";

import Gmail from "../../../../google/gmail";
import SnowflakeSection from "./sections/SnowflakeSection";

const AccountMappingSection = props => {
  const { activeSection, adminSettings, saveSettings, history } = props;

  return (
    <>
      {!activeSection && (
        <>
          <Link
            to={`/admin-settings/${TAB_INTEGRATION}/${INTEGRATION_ACCOUNT_MAPPING_URL_TAB}/${TAB_CROSSBEAM}`}
            className="onboarding-link mb-2"
          >
            <div className="onboarding-header">
              <div className="step-wrapper">
                <span className="step-count d-block completed">
                  <SettingsCrossbeamIcon />
                </span>
              </div>
            </div>
            <div className="onboarding-main">
              <h5 className="font-weight-bold">Crossbeam</h5>
              <p className="font-weight-bold text-inline-grayed">
                Account mapping with Crossbeam
              </p>
            </div>
            <div className="onboarding-url">
              <ChevronRight />
            </div>
          </Link>
          <Link
            to={`/admin-settings/${TAB_INTEGRATION}/${INTEGRATION_ACCOUNT_MAPPING_URL_TAB}/${TAB_REVEAL}`}
            className="onboarding-link"
          >
            <div className="onboarding-header">
              <div className="step-wrapper">
                <span className="step-count d-block completed">
                  <SettingsRevealIcon />
                </span>
              </div>
            </div>
            <div className="onboarding-main">
              <h5 className="font-weight-bold">Reveal</h5>
              <p className="font-weight-bold text-inline-grayed">
                Account mapping with Reveal
              </p>
            </div>
            <div className="onboarding-url">
              <ChevronRight />
            </div>
          </Link>

          <Link
            to={`/admin-settings/${TAB_INTEGRATION}/${INTEGRATION_ACCOUNT_MAPPING_URL_TAB}/${TAB_GMAIL}`}
            className="onboarding-link mt-2"
          >
            <div className="onboarding-header">
              <div className="step-wrapper">
                <span className="step-count d-block completed">
                  <GmailIcon />
                </span>
              </div>
            </div>
            <div className="onboarding-main">
              <h5 className="font-weight-bold">Gmail</h5>
              <p className="font-weight-bold text-inline-grayed">
                Account mapping with Gmail
              </p>
            </div>
            <div className="onboarding-url">
              <ChevronRight />
            </div>
          </Link>
        </>
      )}

      <TabContent activeTab={activeSection}>
        <TabPane tabId={TAB_CROSSBEAM} className="w-100">
          <CrossbeamSection
            activeSection={activeSection}
            adminSettings={adminSettings}
            saveSettings={saveSettings}
            history={history}
          />
        </TabPane>

        <TabPane tabId={TAB_REVEAL} className="w-100">
          <div className="text-center" style={{ marginTop: "40%" }}>
            <h4>Coming soon...</h4>
          </div>
          {/* <RevealSection
            activeSection={activeSection}
            adminSettings={adminSettings}
            saveSettings={saveSettings}
            history={history}
          /> */}
        </TabPane>

        <TabPane tabId={TAB_GMAIL} className="w-100">
          <Gmail
            activeSection={activeSection}
            adminSettings={adminSettings}
            saveSettings={saveSettings}
            history={history}
          />
        </TabPane>
      </TabContent>
    </>
  );
};

export default AccountMappingSection;
